import React, {useEffect} from 'react';
import {createRoot} from 'react-dom/client';

import SearchTooltip from '@Themes/natucare/modules/Article/components/SearchTooltip/SearchTooltip';

export const useSelectionTooltip = (ref => {
  // extra offset for tooltip's top distance
  const offset = 40;
  const wrapperID = 'searchToolWrapper';
  const hrefSuffix = 'natu.care';

  const handleMouseDown = event => {
    const wrapper = document.getElementById(wrapperID);

    // parentNode for tooltip wrapper when clicked doesn't remove element tooltip
    if (wrapper && event.target.parentNode.parentNode.id !== wrapperID) {
      wrapper.remove();
    }
  };

  const buildHref = string => `https://www.google.com/search?q=${string}`;

  const handleMouseUp = event => {
    const searchTooltipWrapper = document.createElement('div');
    const {target} = event;

    searchTooltipWrapper.setAttribute('id', wrapperID);
    document.body.appendChild(searchTooltipWrapper);

    // get whole text from selected area
    const selectedText = `${document.getSelection().anchorNode.parentNode.textContent.toString()} ${hrefSuffix}`;
    const position = {
      top: target.getBoundingClientRect().top + window.scrollY + offset,
      left: event.pageX
    };
    const href = buildHref(selectedText);

    if (document.getSelection() && document.getSelection().toString().length > 0) {
      createRoot(searchTooltipWrapper).render(<SearchTooltip
        text={selectedText}
        position={position}
        href={href}
        open={true}/>
      );
    }
  };

  useEffect(() => {
    let elements;

    if (ref.current && typeof document !== 'undefined') {
      elements = ref.current.querySelectorAll('h1, h2, h3, h4, h5, h6');

      if (elements) {
        document.addEventListener('mousedown', handleMouseDown.bind(this));

        [].slice.call(elements).forEach(el => {
          el.addEventListener('mouseup', handleMouseUp.bind(this));
        });
      }
    }

    return () => {
      document.removeEventListener('mousedown', handleMouseDown.bind(this));

      if (elements) {
        [].slice.call(elements).forEach(el => {
          el.removeEventListener('mouseup', handleMouseUp.bind(this));
        });
      }
    };
  }, []);
});
